module.exports = __webpack_public_path__ + "img/vendor_logo3.05d71c0d.png";